/** Catálogo de secciones de Administración (antes módulo Sistema). */

export const ADMINISTRATION_CATALOG = [
  {
    key: 'admin',
    title: 'Administración',
    description: 'Usuarios, roles, permisos y avisos de mantención.',
    items: [
      {
        key: 'users',
        title: 'Usuarios',
        description: 'Gestiona cuentas, roles y estado de usuarios.',
        href: '/sistema/admin/users',
      },
      {
        key: 'permissions',
        title: 'Roles y permisos',
        description: 'Define roles de sistema y sus permisos de acceso.',
        href: '/sistema/admin/permissions',
      },
      {
        key: 'maintenance',
        title: 'Mantención',
        description: 'Aviso emergente para los usuarios de la plataforma.',
        href: '/sistema/admin/maintenance',
      },
    ],
  },
  {
    key: 'company',
    title: 'Company',
    description: 'Datos generales y ajustes de la empresa.',
    items: [
      {
        key: 'general',
        title: 'General',
        description: 'Información general de la organización.',
        href: '/sistema/company/general',
      },
      {
        key: 'configuration',
        title: 'Ajustes',
        description: 'Configuración operativa de la empresa.',
        href: '/sistema/company/configuration',
      },
    ],
  },
  {
    key: 'monitoring',
    title: 'Monitoreo',
    description: 'Actividad del sistema y sesiones activas.',
    items: [
      {
        key: 'activity',
        title: 'Actividad',
        description: 'Registro de actividad y auditoría.',
        href: '/sistema/monitoring/activity',
      },
      {
        key: 'sessions',
        title: 'Sesiones',
        description: 'Sesiones activas y control de acceso.',
        href: '/sistema/monitoring/sessions',
      },
    ],
  },
  {
    key: 'datos',
    title: 'Datos',
    description: 'Importación y exportación de información.',
    items: [
      {
        key: 'importacion',
        title: 'Importación',
        description: 'Carga un dump JSON: reemplazar todo o solo agregar faltantes.',
        href: '/sistema/datos/importacion',
      },
      {
        key: 'exportacion',
        title: 'Exportación',
        description: 'Descarga todas las tablas en un archivo JSON.',
        href: '/sistema/datos/exportacion',
      },
    ],
  },
];

export const getAdministrationCategory = (key) =>
  ADMINISTRATION_CATALOG.find((category) => category.key === key) || null;

export const isAdministrationPath = (pathname = '') =>
  String(pathname).startsWith('/administracion') || String(pathname).startsWith('/sistema');
